import styled from "styled-components";

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 45px 20px;
  border-top: 1px solid #4e5574;
  /* background-color: #1d2133; */
  max-height: 80px;
`;

export const FooterText = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 28px;
`;

export const FooterInner = styled.a`
  display: flex;
  justify-content: space-between;
  background-color: #4d525b;
  align-items: center;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  padding: 10px 20px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border: 1px solid rgba(255, 255, 255, 0.4);
  }
`;
